export default __webpack_public_path__ + "static/media/Amazon_PNG6.3298cb99.png";